import {
    List, Collapse, Icon,
    ListItemButton, ListItemText
} from '@mui/material'

import { Fragment, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'
import { createId } from '@services/utils'

import { DEFAULT, SELECTED } from '@services/theme'

import Styles from './style'

export const Submenu = (props) => {
    const navigate = useNavigate()
    const url = useLocation()
    const pathname = url.pathname

    const [open, setOpen] = useState(props.open)

    const handleOpen = (path) => () => {
        setOpen(!open)
        if (path) navigate(path)
    }

    const handleNavigate = (path, target) => () => {
        if (target) return
        navigate(path)
    }

    return (
        <Fragment>
            <ListItemButton
                onClick={handleOpen(props.path)}
                sx={Styles.mainCta}
                className={(props.subOpen) ? SELECTED : DEFAULT}
            >
                {(props.icon) && <Icon>{props.icon}</Icon>}
                <ListItemText primary={props.label} sx={{paddingLeft: '35px'}}/>
                <Icon>{(open) ? 'expand_more' : 'navigate_next'}</Icon>
            </ListItemButton>
            <Collapse in={open} timeout={'auto'} unmountOnExit>
                <List component={'div'} disablePadding>
                    {props.items && props.items.length > 0 && props.items.map(subitem => {
                        const key = createId()
                        return (
                            <ListItemButton
                                key={key}
                                onClick={handleNavigate(subitem.path, subitem.target)}
                                className={(subitem.path === pathname) ? SELECTED : DEFAULT}
                                sx={Styles.subCta}
                                disabled={subitem.disabled}
                            >
                                {(subitem.target === 'blank')
                                    ? (<a href={subitem.path} target={subitem.target} style={Styles.link}><ListItemText primary={subitem.label}/></a>)
                                    : (<ListItemText primary={subitem.label}/>)
                                }
                            </ListItemButton>
                        )
                    })}
                </List>
            </Collapse>
        </Fragment>
    )
}

export default Submenu